import api, { prepareOrdinalsStrayFundsSweep, recoverOrdinalsStrayFunds } from 'api/api'
import { getClientShare, recoverLocalWalletTextWithShares } from './bsv-signing'
import { requireClientSigningFeature } from './clientSigningFeature'
import { signStraySweep } from './ordinals-stray-sweep-signing'

/**
 * "Move to balance" for a wallet whose keys live on this device: the server
 * builds the sweep of the stray (non-inscription) outputs, this device checks
 * and signs it with the ordinals key, and the server broadcasts it.
 */
export async function moveOrdinalsStrayFundsWithDevice() {
    requireClientSigningFeature()
    const userId = gon.currentUser?.id
    if (!userId) throw new Error('Not logged in')

    const clientRecord = await getClientShare(userId)
    if (!clientRecord) throw new Error('This device can’t sign for your wallet yet.')
    const serverShare = await api.getBsvServerShare(userId, clientRecord.deviceId)
    if (!serverShare) throw new Error('Could not unlock your wallet on this device. Try again.')

    const prepared = await prepareOrdinalsStrayFundsSweep()
    const request = prepared.signing_request
    if (!request) {
        if (prepared.recovery) return { ok: true, recovery: prepared.recovery }
        throw new Error('Unable to move the funds')
    }

    const walletText = await recoverLocalWalletTextWithShares(
        userId,
        serverShare.treechatShare,
        clientRecord.clientShare,
    )
    const signedTx = await signStraySweep(request.unsigned_tx_template, JSON.parse(walletText), {
        ordinalsAddress: request.ordinals_address,
        paymentAddress: request.payment_address,
    })
    return recoverOrdinalsStrayFunds({ signing_token: request.signing_token, signed_tx: signedTx })
}
